interface Env {
  apiKey: string;
  authDomain: string;
  projectID: string;
  participantsDNS: string;
  googleAnalyticsID: string;
  announceKitWidget: string;
  amplitudeApiKey: string;
  pingDomain: string;
}

interface WindowWithEnv extends Window {
  env?: Env;
}

const env: Env = (window as WindowWithEnv).env || {
  apiKey: 'AIzaSyAwyZHlNjclUTZfs-M-KCmZUGscMi02xyY',
  authDomain: 'auth.play.instruqt.dev',
  projectID: 'instruqt-dev',
  participantsDNS: 'env.play.instruqt.dev',
  googleAnalyticsID: 'UA-110493831-6',
  announceKitWidget: 'ssPT2',
  amplitudeApiKey: 'd79118565eef4449c76cf4058860a752',
  pingDomain: 'https://ping.instruqt.dev',
};

export default env;
